import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthDataService } from 'src/app/infraestructure/ui/services/auth-data.service';
import { ENVIRONMENT } from 'src/environments/environment';
import { PlanEntity } from '../../domain/entities/plan.entity';
import { PlanPort } from '../../domain/ports/plan.port';
import { PlanMapper } from '../mappers/plan.mapper';
import { PlanModel } from '../models/plan.model';

@Injectable({
  providedIn: 'root',
})
export class LealAPIAdapter extends PlanPort {
  private _planMapper = new PlanMapper();

  constructor(
    private httpClient: HttpClient,
    private authDataService: AuthDataService
  ) {
    super();
  }

  override getPlan(): Observable<PlanEntity> {
    const idCommerce = this.authDataService.getUserData()?.idCommerce;
    const countryCode = this.authDataService.getUserData()?.countryCode;

    const httpHeaders = new HttpHeaders({
      'cod-pais': countryCode || 'CO',
    });

    return this.httpClient
      .get<{ data: PlanModel; message: string }>(
        `${ENVIRONMENT.urls.baseAPI}/v1/authentication/roles-and-plans/commerce/${idCommerce}/communications`,
        { headers: httpHeaders }
      )
      .pipe(
        map((response: { data: PlanModel; message: string }) =>
          this._planMapper.mapFrom(response.data)
        )
      );
  }
}
